import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-recurrences',
  standalone: true,
  imports: [],
  templateUrl: './process-recurrences.component.html',
  styles: ``
})
export class ProcessRecurrencesComponent {
  @Input() process!: Process;
}
